<template>
  <div class="ftp-credentials">
    <!-- Global Credentials -->
    <div v-if="credentials.global" class="credential-section">
      <h5 class="section-title">
        <CIcon name="cipGlobe" size="custom-size" :height="18" class="mr-2" />
        <translate translate-context="ftp.credentials">Global</translate>
      </h5>
      <div class="credential-item">
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Username</translate>:
          </span>
          <div class="credential-value">{{ credentials.global.username }}</div>
          <CButton
            color="light"
            class="ml-2 btn-circle"
            @click="copyInClipboard(credentials.global.username, 'Username')"
          >
             <CIcon name="cipCopy" size="custom-size" :height="16" />
          </CButton>
        </div>
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Password</translate>:
          </span>
          <div class="credential-value">{{ credentials.global.password }}</div>
          <CButton
            color="light"
            class="ml-2 btn-circle"
            @click="copyInClipboard(credentials.global.password, 'Password')"
          >
            <CIcon name="cipCopy" size="custom-size" :height="16" />
          </CButton>
        </div>
      </div>
    </div>

    <!-- Pica Service Credentials -->
    <div v-if="credentials.pica_service" class="credential-section">
      <h5 class="section-title">
        <CIcon name="cipPicture" size="custom-size" :height="18" class="mr-2" />
        <translate translate-context="ftp.credentials">Pica service</translate>
      </h5>
      <div class="credential-item">
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Username</translate>:
          </span>
          <div class="credential-value">{{ credentials.pica_service.username }}</div>
          <CButton
            color="light"
            class="ml-2 btn-circle"
            @click="copyInClipboard(credentials.pica_service.username, 'Username')"
          >
            <CIcon name="cipCopy" size="custom-size" :height="16" />
          </CButton>
        </div>
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Password</translate>:
          </span>
          <div class="credential-value">{{ credentials.pica_service.password }}</div>
          <CButton
            color="light"
            class="ml-2 btn-circle"
            @click="copyInClipboard(credentials.pica_service.password, 'Password')"
          >
             <CIcon name="cipCopy" size="custom-size" :height="16" />
          </CButton>
        </div>
      </div>
    </div>

    <!-- Gallery Credentials -->
    <div v-if="credentials.galleries && credentials.galleries.length > 0" class="credential-section">
      <h5 class="section-title">
        <CIcon name="cipPicture" size="custom-size" :height="18" class="mr-2" />
        <translate translate-context="ftp.credentials">Galleries</translate>
      </h5>
      <div v-for="gallery in credentials.galleries" :key="gallery.id" class="gallery-credentials">
        <GalleryCredential :gallery="gallery" :level="0" />
      </div>
    </div>

    <!-- No credentials message -->
    <div v-if="!hasAnyCredentials" class="text-center font-weight-medium py-4">
      <translate translate-context="ftp.credentials">No FTP credentials available</translate>
    </div>
  </div>
</template>

<script>
import GalleryCredential from './GalleryCredential.vue'

export default {
  name: 'FtpCredentialDisplay',

  components: {
    GalleryCredential
  },

  props: {
    credentials: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  computed: {
    hasAnyCredentials() {
      return !!(
        this.credentials.global ||
        this.credentials.pica_service ||
        (this.credentials.galleries && this.credentials.galleries.length > 0)
      )
    }
  }
}
</script>

<style scoped>
.ftp-credentials {
  padding: 0.5rem 0;
}

.credential-section {
  margin-bottom: 2rem;
}

.credential-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
}

.credential-item {
  background: #FAFAFA;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.5rem;
}

.credential-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.credential-row:last-child {
  margin-bottom: 0;
}

.credential-label {
  font-weight: 500;
  min-width: 100px;
}

.credential-value {
  border-radius: 6px;
  background: #FFF;
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.gallery-credentials {
  margin-bottom: 0.5rem;
}


</style>
